import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Link } from 'react-router-dom';
import Login from './Login';
import wisLogo from "../../wis.png";
import offButton from "../../power-button-off.svg";

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/
export class App extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    children: '',
  };

  navigationList = [
    {link: '/', title: 'Übersicht'},
    // {link: '/school-classes', title: 'Klassen'},
    {link: '/access', title: 'Lizenzen'},
    {link: '/products', title: 'Produkte'},
    // {link: '/events', title: 'Termine'},
  ];

  logout = () => {
    localStorage.clear();
    window.location.replace('/');
  };

  render() {
    const { location: { pathname }, home: { user: { isLoggedIn, loginPending }, user } } = this.props;
    let first_name = '';
    let last_name = '';
    if (user.authenticationModel) {
      first_name = user.authenticationModel.user.first_name;
      last_name = user.authenticationModel.user.last_name;
    }
    return isLoggedIn ? (
      <div className="container-fluid">
        <div className="row">
          <nav className="col-md-2 d-md-block bg-light sidebar">
            <div className="sidebar-logo">
              <span className="sidebar-logo-username">{`${first_name} ${last_name}`}</span>
              <div className="sidebar-actions">
                <button onClick={this.logout} className="btn"><img src={offButton} /></button>
              </div>
              <img src={wisLogo} alt="user logo" />
            </div>
            <div className="sidebar-sticky">
              <ul className="nav flex-column">
                {this.navigationList.map(item => (
                  <li key={item.title} className={`nav-item ${pathname === item.link ? 'active' : ''}`}>
                    <Link className={`nav-link ${pathname === item.link ? 'active' : ''}`} to={item.link}>
                      <span>{item.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
          <main className="content col-md-10 ml-sm-auto col-lg-10 pt-3 px-4">
            {this.props.children}
          </main>
        </div>
      </div>
    ) : <Login login={this.props.actions.login} />;
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/features/home/App.js